import type { CityConfig } from "../city-template/types";

export const rockSpringsConfig: CityConfig = {
  city: "Rock Springs",
  state: "Wyoming",
  stateAbbr: "WY",
  slug: "rock-springs",
  route: "/cities/rock-springs",
  title: "Emergency Passport Rock Springs, WY — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Rock Springs, WY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Rock Springs, Green River, Sweetwater County, and southwestern Wyoming travelers. No Denver or Salt Lake trip needed.",
  h1: "Emergency & Expedited Passport Services in Rock Springs, WY",
  heroSubtitle: "Trona mining professional heading to an international conference? Flaming Gorge recreation enthusiast planning a cross-border trip? Sweetwater County family booking a vacation abroad? We help Rock Springs residents — from energy workers to Western Wyoming Community College students to Green River Basin families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Expansive%20high%20desert%20landscape%20of%20Rock%20Springs%20Wyoming%20with%20the%20distinctive%20sandstone%20formations%20and%20buttes%20of%20the%20Green%20River%20Basin%20under%20a%20dramatic%20big%20sky%2C%20the%20historic%20downtown%20with%20western%20architecture%20along%20the%20old%20Union%20Pacific%20Railroad%20corridor%2C%20rugged%20high%20desert%20scenery%20with%20sagebrush%20and%20distant%20mountains%2C%20warm%20golden%20hour%20light%2C%20editorial%20travel%20photography%20style&width=1800&height=700&seq=rocksprings-hero-2026&orientation=landscape",
  heroImageAlt: "Rock Springs Wyoming in the Green River Basin at golden hour with sandstone buttes",
  geoPosition: "41.5875;-109.2029",
  geoPlacename: "Rock Springs, Wyoming",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 510, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 350 miles from Rock Springs via I-80; a 5.5+ hour drive one way",
  },
  nearbyCitiesZips: [
    { name: "Rock Springs", zips: "82901, 82902" },
    { name: "Green River", zips: "82935" },
    { name: "Superior", zips: "82945" },
    { name: "Reliance", zips: "82943" },
    { name: "Farson", zips: "82932" },
    { name: "Eden", zips: "82932" },
    { name: "Wamsutter", zips: "82336" },
    { name: "Evanston", zips: "82930" },
  ],
  benefits: [
    { icon: "ri-oil-line", title: "Trona & Energy Sector International Expertise", desc: "Sweetwater County is home to the world's largest trona deposit and major natural gas production. Energy and mining professionals frequently travel to international conferences, supplier meetings, and overseas project sites. We understand the industry's short-notice travel patterns." },
    { icon: "ri-flight-takeoff-line", title: "RKS — Rock Springs-Sweetwater County Airport", desc: "RKS connects to Denver International Airport via United Express. DIA is a major international gateway 350 miles away. We coordinate passport timelines around RKS connections." },
    { icon: "ri-building-2-line", title: "Between Two Agencies — Denver and Salt Lake City", desc: "Rock Springs sits roughly equidistant between Denver (350 miles) and Salt Lake City (190 miles). Neither is convenient for a same-day passport agency visit. Our courier service bridges both gaps." },
    { icon: "ri-home-2-line", title: "Flaming Gorge & Cross-Border Recreation", desc: "Flaming Gorge National Recreation Area draws outdoor enthusiasts who often continue north into Utah and beyond. Many Rock Springs residents regularly cross international borders for outdoor adventures, making passport readiness essential." },
  ],
  internalLinks: [
    { name: "Expedited passport in Evanston, WY", route: "/cities/evanston-wy" },
    { name: "Fast passport services in Casper, WY", route: "/cities/casper" },
    { name: "Quick passport in Salt Lake City, UT", route: "/cities/salt-lake-city" },
    { name: "Urgent passport services in Laramie, WY", route: "/cities/laramie" },
    { name: "Wyoming passport services overview", route: "/cities/wyoming-state" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 510, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Rock Springs via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 5.5+ hours to Colorado or 3+ hours to Salt Lake City. Rock Springs residents can ship from any UPS Store, FedEx Office, or post office location across Sweetwater County.",
  fpcOfficeDistance: "Serving Rock Springs, Green River, Superior, Reliance, Farson, Eden, Wamsutter, and all Sweetwater County and southwestern Wyoming communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rock Springs and Sweetwater County. From the historic downtown district along Broadway to the mining operations north of town, from the Green River corridor to the high desert communities of the Red Desert — we serve all of southwestern Wyoming. Our courier service eliminates the need to drive to Denver or Salt Lake City for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Rock Springs and all Sweetwater County communities including Green River, Superior, and Reliance. We also serve trona mining professionals, WWCC students, and Green River Basin families planning international travel.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Rock Springs as simple as possible — with the reliability Sweetwater County energy workers, WWCC students, and Rock Springs families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Rock Springs travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Rock Springs travelers encounter unique passport issues — from mining sector international assignment deadlines to Sweetwater County address verification to Flaming Gorge cross-border recreation documentation. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Southwestern Wyoming travelers — from Green River Basin energy professionals to Flaming Gorge outdoor guides to Sweetwater County families — trust us when their international departure is days away and neither Denver nor Salt Lake City is practical.",
  faqIntro: "Have questions about expedited passports in Rock Springs, WY? Here are the most common ones we hear from Sweetwater County travelers.",
  statePageRoute: "/cities/wyoming-state",
  statePageName: "Wyoming",
  servicesIntro: "Whether you need a renewal before an international mining conference, an emergency passport for a last-minute RKS connection, or a first-time passport for a Sweetwater County family vacation abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.state.wy.us/driverservices",
  dmvLabel: "Wyoming Department of Transportation — Driver Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 350 miles from Rock Springs", "5.5+ hour drive — completely impractical for Sweetwater County residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver or Salt Lake City trip needed", "Ideal for mining sector international assignments", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Rock Springs or Green River", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "RKS connection for an international mining conference in 2 days? Last-minute overseas project assignment? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Rock Springs travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Rock Springs residents renew fast — no agency visit required. Perfect for trona mining professionals and Sweetwater County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Sweetwater County residents through every step with clear instructions.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed — so your international assignment or family vacation stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions for your Sweetwater County family trip abroad.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for mining professionals with overlapping international assignments and business travel.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Sweetwater County travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Flaming Gorge recreation trips into Utah and beyond.",
      bullets: ["Wallet-size convenience", "Land and sea crossings", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rock Springs WY", description: "Urgent passport processing for Rock Springs Wyoming travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Rock Springs WY", description: "Fast passport renewal for Rock Springs Wyoming residents with a previously-issued passport." },
    { name: "First-Time Passport Rock Springs WY", description: "New passport application services for Rock Springs Wyoming residents applying for their first passport." },
    { name: "Child Passport Rock Springs WY", description: "Minor passport services for Rock Springs Wyoming families with children under 16." },
    { name: "Name Change Passport Rock Springs WY", description: "Passport name correction after marriage, divorce, or legal name changes for Rock Springs residents." },
    { name: "Second Passport Rock Springs WY", description: "Second passport services for Rock Springs frequent travelers and mining sector professionals." },
  ],
  testimonials: [
    {
      name: "Dennis P.",
      location: "Rock Springs",
      rating: 5,
      text: "Trona industry conference in Turkey with 3 weeks notice. My passport was expired and the nearest agency is Denver — 350 miles away. Fast Passport Center got my renewal done in 4 days. I made the conference. This service is essential for Sweetwater County.",
      service: "Passport Renewal",
    },
    {
      name: "The Gutierrez Family",
      location: "Green River",
      rating: 5,
      text: "Family reunion in Mexico — three kids needed first passports. Fast Passport Center handled everything, caught a photo issue, and got all five passports in time. The Green River post office acceptance was smooth with their checklist.",
      service: "New Passports — Family",
    },
    {
      name: "Rachel L.",
      location: "Rock Springs",
      rating: 5,
      text: "WWCC student heading to Spain for a semester abroad. Realized my passport was expiring 6 weeks before departure. Fast Passport Center expedited my renewal and I had it in 5 days. Without them I would have missed the program start.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Tom S.",
      location: "Superior",
      rating: 5,
      text: "Living in Superior, the idea of driving to Denver or Salt Lake for a passport is absurd. Needed a replacement after my wallet was stolen. Fast Passport Center handled everything remotely — got my new passport in 6 days. Incredible service for rural southwestern Wyoming.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "rocksprings-1",
      name: "Rock Springs Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2829 Commercial Way",
      city: "Rock Springs",
      state: "WY",
      zip: "82901",
      phone: "(307) 362-6216",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Rock Springs",
      website: "https://tools.usps.com/find-location.htm?location=1372229",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Sweetwater County. Appointment availability can be limited — schedule at least a week in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "rocksprings-2",
      name: "Sweetwater County Clerk of District Court",
      type: "County Clerk Passport Acceptance",
      address: "80 W Flaming Gorge Way, Suite 150",
      city: "Green River",
      state: "WY",
      zip: "82935",
      phone: "(307) 872-3890",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Green River — Sweetwater County Courthouse, about 15 miles west of Rock Springs",
      website: "https://www.sweetwatercountywy.gov/",
      websiteLabel: "Sweetwater County Website",
      notes: "Alternative to post office acceptance facilities. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "rocksprings-3",
      name: "Green River Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "350 Uinta Dr",
      city: "Green River",
      state: "WY",
      zip: "82935",
      phone: "(307) 875-3954",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Green River — about 15 miles west of Rock Springs via I-80",
      website: "https://tools.usps.com/find-location.htm?location=1366031",
      websiteLabel: "USPS Location",
      notes: "Serves Green River and western Sweetwater County. Good alternative when Rock Springs appointments are fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "rocksprings-4",
      name: "Evanston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 Overthrust Rd",
      city: "Evanston",
      state: "WY",
      zip: "82930",
      phone: "(307) 789-7934",
      hours: "Mon–Fri 8:30 AM – 4:30 PM (appointment required)",
      distance: "Evanston — about 100 miles west of Rock Springs via I-80",
      website: "https://tools.usps.com/find-location.htm?location=1365135",
      websiteLabel: "USPS Location",
      notes: "Larger facility serving Uinta County. About 1.5 hours from Rock Springs — useful when traveling I-80 west.",
      icon: "ri-mail-line",
    },
    {
      id: "rocksprings-5",
      name: "Western Wyoming Community College",
      type: "Campus Passport Services",
      address: "2500 College Dr",
      city: "Rock Springs",
      state: "WY",
      zip: "82901",
      phone: "(307) 382-1600",
      hours: "Mon–Fri 8:00 AM – 5:00 PM (limited passport services — call for availability)",
      distance: "Rock Springs — WWCC Campus",
      website: "https://www.westernwyoming.edu/",
      websiteLabel: "WWCC Website",
      notes: "Limited passport services primarily for students and staff. Call ahead to confirm current passport acceptance availability.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 350 miles and 5.5+ hour drive from Rock Springs one way", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO; 11+ hour round trip from Rock Springs", fpc: "Most Rock Springs travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, especially problematic from rural southwestern Wyoming", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Rock Springs Residents", agency: "350-mile one-way drive to Denver — completely impractical for Sweetwater County residents", fpc: "Entirely remote — forms online, ship from Rock Springs, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Denver, time off work, and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Sweetwater County Context", agency: "No Rock Springs-specific guidance — no trona mining, WWCC, or Flaming Gorge expertise", fpc: "Full Sweetwater County knowledge — mining sector, WWCC, Green River Basin travel patterns" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Mining Sector International Assignment Timing",
      description: "Trona and energy sector professionals in Sweetwater County often receive international assignment notices with 2-3 weeks lead time. An expired passport at that point means a frantic scramble. Maintain passport validity as a standard professional practice.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Forgetting the RKS Connection Is the First Checkpoint",
      description: "RKS connects to Denver International Airport. Your passport is checked at Rock Springs check-in — not at DIA. An expired or near-expired passport will prevent boarding at RKS even if your international flight departs from Denver hours later.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Green River Basin Address Formatting Issues",
      description: "Rural Sweetwater County addresses, especially in Superior, Reliance, and Farson, can differ between mailing addresses and physical addresses. Mismatched addresses cause delays. We review all documentation for address consistency.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards from High Desert Retailers",
      description: "Photos from Rock Springs retail locations may not meet strict State Department standards — particularly lighting and background issues common in smaller-market photo services. We catch these in review before rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Either Denver or SLC Is Convenient",
      description: "Rock Springs sits between Denver (350 miles) and Salt Lake City (190 miles). Neither is practical for a same-day passport agency visit. Our courier channel is the only realistic expedited option for southwestern Wyoming.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether a mining conference, family vacation, or WWCC study abroad program." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — mining professional, student, or Sweetwater County family." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Rock Springs clients ship from the UPS Store on Dewar Drive or the Rock Springs Post Office on Commercial Way." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Sweetwater County travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Rock Springs, Green River, or Sweetwater County address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Rock Springs, Wyoming?", a: "We offer Rock Springs-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest regional passport agency is in Denver (350 miles away) — our remote courier service is the most practical fast option in Sweetwater County." },
    { q: "Do I need to visit a Rock Springs office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Rock Springs Post Office or Sweetwater County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Sweetwater County address." },
    { q: "Where can I get passport acceptance near Rock Springs?", a: "Rock Springs has acceptance facilities at the Main Post Office on Commercial Way and nearby USPS locations in Green River. The Sweetwater County Clerk of District Court in Green River also offers acceptance services. We maintain an updated list of area facilities." },
    { q: "I work in the trona mining industry — can you handle short-notice passport needs?", a: "Yes. Sweetwater County mining and energy professionals are among our most frequent clients. When international conferences, equipment training, or overseas site visits come up with 2-3 weeks notice, we provide fast expedited processing. No Denver or Salt Lake City drive required." },
    { q: "Is Salt Lake City a viable alternative to Denver for passport agency appointments?", a: "Salt Lake City is 190 miles from Rock Springs (closer than Denver at 350 miles), but SLC does not have a regional passport agency — only acceptance facilities. Denver is the nearest agency. For expedited processing, our courier service eliminates the need for either city." },
    { q: "What is the best price for expedited passport service in Rock Springs?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Rock Springs applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent. We provide a Sweetwater County-specific checklist." },
    { q: "Can I get a passport photo in Rock Springs?", a: "Yes. The Rock Springs Post Office offers limited on-site passport photos. CVS, Walgreens, and the UPS Store on Dewar Drive also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does RKS airport connect to international flights?", a: "Rock Springs-Sweetwater County Airport (RKS) connects to Denver International Airport (DIA) via United Express. DIA offers direct international flights worldwide. Your passport must be valid when you check in at RKS." },
    { q: "Can you help with passports for WWCC students?", a: "Yes. Western Wyoming Community College students heading abroad for study programs or transferring to international universities need timely passport processing. We help WWCC students navigate the process with clear checklists and fast expedited service." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Rock Springs Residents",
    intro: "Rock Springs' position in the Green River Basin, along I-80 in southwestern Wyoming, and as the trona mining capital of the world creates unique passport timing considerations. Here's what Sweetwater County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "RKS — Rock Springs-Sweetwater County Airport",
        subtitle: "The essential first leg for southwestern Wyoming international travel",
        description: "RKS connects to Denver International Airport via United Express. From DIA, travelers access direct flights worldwide. The critical insight: your passport is checked at RKS check-in, not at DIA. If your passport isn't valid, you won't board in Rock Springs.",
        tip: "Check your passport expiration when you book any itinerary departing from RKS. Weather in southwestern Wyoming can delay RKS connections — build in buffer time for international itineraries, especially in winter.",
      },
      {
        icon: "ri-oil-line",
        title: "Trona Mining & Energy Sector International Travel",
        subtitle: "The world's largest trona deposit drives global business connections",
        description: "Sweetwater County produces the majority of the world's soda ash from trona. Industry professionals regularly travel to international mining conferences, equipment expos, and supplier meetings in Turkey, China, Germany, and Chile. These trips often have 2-4 weeks notice, making fast passport processing essential.",
        tip: "Mining and energy professionals should treat passport validity like any other critical professional credential — check it quarterly, not just before a trip. An unexpected international opportunity won't wait for passport processing.",
      },
      {
        icon: "ri-road-map-line",
        title: "I-80 Corridor — The Transcontinental Crossroads",
        subtitle: "Rock Springs' position on America's most important east-west interstate",
        description: "I-80 runs directly through Rock Springs, connecting the city to Salt Lake City (190 miles west), Cheyenne (310 miles east), and Denver (350 miles southeast). This corridor gives Rock Springs travelers access to major airports: RKS for regional connections, SLC for Delta hub access, and DIA for global connections.",
        tip: "Salt Lake City International Airport (SLC) is 190 miles west and offers extensive international connections as a Delta hub. For some international itineraries, driving to SLC may be more convenient than connecting through Denver from RKS.",
      },
      {
        icon: "ri-landscape-line",
        title: "Flaming Gorge & Cross-Border Outdoor Recreation",
        subtitle: "World-class recreation draws international visitors and sends locals abroad",
        description: "Flaming Gorge National Recreation Area, just south of Rock Springs, attracts outdoor enthusiasts from around the world. Many Rock Springs residents are avid outdoor adventurers who regularly travel to Canada (Banff, Canadian Rockies), Mexico (Baja), and South America (Patagonia) for fishing, climbing, and backcountry expeditions.",
        tip: "Outdoor adventurers should check passport expiration before booking international trips. Many guide services and lodges in Patagonia, the Canadian Rockies, and Baja require passport information at booking, not at departure.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Rock Springs & the Green River Basin",
      description: "Rock Springs was built by the Union Pacific Railroad and coal mining in the 19th century, and its multicultural heritage — nicknamed the 'City of 56 Nationalities' — reflects waves of immigration from Europe, Asia, and Latin America who came to work the mines. Today, the trona mining industry and Flaming Gorge recreation anchor the community, creating a unique blend of industrial heritage and outdoor adventure that shapes the international travel patterns of southwestern Wyoming.",
    },
  },
  destinations: {
    title: "Where Rock Springs Travelers Go — And Why Passports Get Urgent",
    intro: "Rock Springs' identity as a trona mining hub on the I-80 corridor and gateway to Flaming Gorge shapes its international travel patterns.",
    stats: [
      { stat: "40%", label: "of Rock Springs expedited requests involve mining and energy sector travel" },
      { stat: "2–4 Weeks", label: "average lead time for mining sector international assignments" },
      { stat: "Jun–Sep", label: "peak season for outdoor recreation and summer family travel" },
      { stat: "350 Miles", label: "to nearest passport agency in Denver — our courier service bridges this" },
    ],
    destinations: [
      { name: "Middle East & Turkey", context: "Trona and soda ash industry conferences in Turkey, UAE energy expos, Saudi Arabia mining sector meetings", urgency: "Conference invitations with 2–4 week lead time", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Canadian Rockies outdoor adventures, Banff and Jasper climbing and hiking, Calgary business connections, Saskatchewan energy collaboration", urgency: "Seasonal outdoor trips and business travel", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Germany mining equipment trade shows, UK and Ireland heritage travel, WWCC study abroad programs", urgency: "Trade show dates and academic program deadlines", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Chile and Peru mining sector conferences, Patagonia fishing and climbing expeditions, Argentina agricultural programs", urgency: "Southern Hemisphere summer season bookings", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "China soda ash market conferences, Japan and South Korea mining technology partnerships, Southeast Asia equipment training", urgency: "Trade and partnership travel with fixed dates", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Baja fishing trips, winter getaways, resort vacations, language immersion programs", urgency: "Fall and winter travel planning", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Wyoming Service Areas",
    crossLinksDesc: "We serve travelers across the Equality State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Evanston", route: "/cities/evanston-wy" },
      { name: "Casper", route: "/cities/casper" },
      { name: "Salt Lake City, UT", route: "/cities/salt-lake-city" },
    ],
  },
  photoLocations: [
    { name: "Rock Springs Main Post Office", address: "2829 Commercial Way, Rock Springs, WY 82901", hours: "Mon–Fri 9 AM – 4 PM (limited photo service)" },
    { name: "The UPS Store — Rock Springs", address: "2441 Foothill Blvd, Rock Springs, WY 82901", hours: "Mon–Fri 8:30 AM – 6:30 PM, Sat 10 AM – 3 PM" },
    { name: "Walmart Supercenter — Rock Springs", address: "201 Gateway Blvd, Rock Springs, WY 82901", hours: "Daily 6 AM – 11 PM" },
    { name: "Walgreens — Rock Springs", address: "2451 Foothill Blvd, Rock Springs, WY 82901", hours: "Daily 8 AM – 10 PM" },
    { name: "Smith's Food & Drug — Green River", address: "905 Bridger Dr, Green River, WY 82935", hours: "Daily 6 AM – 11 PM" },
    { name: "Walgreens — Evanston", address: "233 Front St, Evanston, WY 82930", hours: "Daily 8 AM – 10 PM (100 miles west)" },
  ],
  dmvLocations: [
    {
      name: "Sweetwater County Treasurer — Motor Vehicle Division",
      address: "80 W Flaming Gorge Way, Suite 108, Green River, WY 82935",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended. Located in Green River, about 15 miles west of Rock Springs.",
      featured: true,
    },
    {
      name: "WyDOT Driver Services — Evanston",
      address: "350 City View Dr, Evanston, WY 82930",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full driver services including testing and REAL ID. About 100 miles west of Rock Springs.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RKS",
      name: "Rock Springs-Sweetwater County Airport",
      distance: "About 8 miles east of downtown Rock Springs (15 minutes via I-80)",
      address: "382 Highway 370, Rock Springs, WY 82901",
      note: "Connects to Denver International Airport via United Express. Free parking. The primary departure point for southwestern Wyoming international travelers.",
      flightUrl: "https://www.flyrks.com/",
      flightLabel: "Rock Springs Airport",
      featured: true,
    },
    {
      code: "SLC",
      name: "Salt Lake City International Airport",
      distance: "About 190 miles west of Rock Springs (3 hours via I-80)",
      address: "776 N Terminal Dr, Salt Lake City, UT 84122",
      note: "Major Delta hub with extensive international connections. Alternative for Rock Springs travelers needing direct international flights without DIA connections.",
      flightUrl: "https://www.slcairport.com/",
      flightLabel: "Salt Lake City Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Wyoming birth certificates from the Wyoming Department of Health Vital Statistics Services. Online, mail, or in-person options available.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Wyoming Vital Statistics Services. Required for estate and legal matters in Sweetwater County.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Sweetwater County Clerk of District Court. Certified copies available for name changes and passport applications.",
      url: "https://www.sweetwatercountywy.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Sweetwater County District Court. Required for name change passport corrections.",
      url: "https://www.sweetwatercountywy.gov/",
    },
  ],
};